import React from 'react';
import '../styles/Projects.css';
import project1 from '../assets/project1.png';
import project2 from '../assets/project2.png';
import project3 from '../assets/project3.png';
import project4 from '../assets/project4.png';
import project5 from '../assets/project5.png';
import project6 from '../assets/project6.png';
import project7 from '../assets/project7.png';

function Projects() {
  const projects = [
    {
      title: 'ClipTrace（ブラウザ拡張）',
      desc: 'コピー操作を自動で記録し、履歴管理やハイライト機能付きジャンプを実現するブラウザ拡張機能。プライバシー保護やサイト別ブラックリストにも対応。',
      img: project7,
      link: 'https://www.cliptrace.app/'
    },
    {
      title: 'Voiceger（音声ソフト）',
      desc: 'ずんだもん公式ボイスに対応した TTS / VC アプリの開発を担当。精度改善、Windowsインストーラの実装、Web API の設計・実装など、開発全体を幅広く支援しました。',
      img: project6,
      link: 'https://zunko.jp/voiceger.php'
    },
    {
      title: 'AI社員導入サービス（Slack連携）',
      desc: 'Slack上で24/7稼働するAIエージェントがFAQ対応、タスク整理、ドキュメント横断検索、要約を自動化。安全性と運用性を検証、本番展開まで支援。',
      img: project5,
      link: 'https://aiworkhub.app/'
    },
    {
      title: '電子商取引向検索システム',
      desc: '仕入れ先や商品、販売情報を統合し、チャットベースで効率的な検索を実現。RAG技術を用いて高精度な情報取得を可能にしました。',
      img: project1
    },
    {
      title: '企業分析レポート自動生成システム',
      desc: '企業の決算情報や財務指標をもとに高品質なグラフを作成し、LLMを用いて詳細な分析レポートを自動生成。投資判断の精度を向上させます。',
      img: project2
    },
    {
      title: 'Lipsync検出および音声合成モデルPoC',
      desc: 'Lipsync（唇の動きと音声の同期）を検出し、音声の合成判定を行うモデルを開発。コード調整やモデル訓練を通じて精度を向上させました。',
      img: project3
    },
    {
      title: 'RAG評価システムの構築とテスト',
      desc: 'RAGモデルの評価フレームワークを構築し、検索結果や生成テキストの精度をテスト。LLMOpsの手法を活用しました。',
      img: project4
    }
  ];

  return (
    <section id="projects" className="projects">
      <div className="projects-header">
        <h2>実績</h2>
      </div>
      <div className="projects-container">
        {projects.map((project, index) => (
          project.link ? (
            <a
              key={index}
              href={project.link}
              className="project-card-link"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="project-card">
                <img src={project.img} alt={project.title} className="project-image" />
                <h3 className="project-title">{project.title}</h3>
                <p className="project-desc">{project.desc}</p>
              </div>
            </a>
          ) : (
            <div key={index} className="project-card">
              <img src={project.img} alt={project.title} className="project-image" />
              <h3 className="project-title">{project.title}</h3>
              <p className="project-desc">{project.desc}</p>
            </div>
          )
        ))}
      </div>
    </section>
  );
}

export default Projects;
